import React from 'react';
import { connect } from 'react-redux';
import { RootState } from 'reducers';
import { RouteComponentProps } from 'react-router-dom';
import { Constants } from 'utils';
import { Table, Pagination, Tooltip, Select, Modal } from 'components';
import { CleanIcon, ViewIcon, EditIcon } from 'assets/icons';
import { ReferralService } from 'services';
import moment from 'moment';
import ModalProcess from './modal-process';

interface Props extends RootState, RouteComponentProps {
  dispatch: any;
}

const INITIAL_STATE = {
  status: '',
};

const PER_PAGE = 10;

const STATUS_LABELS: Record<number, string> = {
  [Constants.REFERRAL_WITHDRAWAL_STATUS.PENDING]: 'Pendiente',
  [Constants.REFERRAL_WITHDRAWAL_STATUS.PAID]: 'Pagado',
  [Constants.REFERRAL_WITHDRAWAL_STATUS.REJECTED]: 'Rechazado',
};

class AdminReferrals extends React.Component<Props> {
  state = {
    header: ['ID', 'Fecha solicitud', 'Usuario', 'Monto', 'Estado', 'Fecha procesado', 'Acciones'],
    form: INITIAL_STATE,
    data: [],
    page: 1,
    last_page: 1,
    item: null,
    visible: false,
  };

  componentDidMount() {
    if (this.props.user?.level_id !== Constants.LEVELS.ADMIN) {
      this.props.history.replace('/');
      return;
    }

    this.props.dispatch({
      type: 'SET_HEADER',
      payload: {
        title: 'Retiros de Referidos',
        onBack: null,
      },
    });

    this.props.dispatch({
      type: 'SET_SUBHEADER',
      payload: {
        title: '',
      },
    });

    this.load();
  }

  load = async (withoutLoading: boolean = false) => {
    const res: any = await ReferralService.admin.get({
      withoutLoading,
      page: this.state.page,
      per_page: PER_PAGE,
      status: this.state.form.status ? Number(this.state.form.status) : undefined,
    });
    this.setState({
      data: res.rows || [],
      last_page: Math.max(1, Math.ceil((res.count || 0) / PER_PAGE)),
    });
  };

  reset = () => {
    this.setState(
      {
        form: INITIAL_STATE,
        page: 1,
      },
      () => this.load(true),
    );
  };

  change = (e: any, callback = () => {}) => {
    this.setState(
      {
        page: 1,
        form: {
          ...this.state.form,
          [e.target.name]: e.target.value,
        },
      },
      callback,
    );
  };

  view = (e: any, item: any) => {
    e.preventDefault();
    this.setState({
      visible: true,
      item,
    });
  };

  onClose = () => {
    this.setState(
      {
        visible: false,
        item: null,
      },
      () => this.load(true),
    );
  };

  render() {
    const { visible } = this.state;

    return (
      <div id='admin-referrals'>
        <Modal
          className='modal-view-referral-withdrawal'
          visible={visible}
          title='Solicitud de retiro'
          onClose={() => this.onClose()}
        >
          <ModalProcess item={this.state.item} onClose={() => this.onClose()} />
        </Modal>

        <div className='row row-filter'>
          <div className='col-md-12'>
            <div className='row'>
              <div className='col-md-3'>
                <Select
                  color='white'
                  placeholder='Todos'
                  label='Estado'
                  name='status'
                  onChange={(e: any) =>
                    this.change(e, async () => {
                      this.load(true);
                    })
                  }
                  value={this.state.form.status}
                  options={Object.entries(STATUS_LABELS).map(([value, label]) => ({
                    value,
                    label,
                  }))}
                />
              </div>
              <div className='col-md-1'>
                {this.state.form != INITIAL_STATE && (
                  <button className='btn btn-clean' onClick={() => this.reset()}>
                    <img src={CleanIcon} />
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>

        <Table
          title='Retiros de Referidos'
          data={this.state.data.length}
          header={this.state.header}
          rightAlign={[6]}
        >
          {this.state.data.map((i: any, index: number) => {
            const itemNumber = (this.state.page - 1) * PER_PAGE + index + 1;
            const isPending = i.status === Constants.REFERRAL_WITHDRAWAL_STATUS.PENDING;

            return (
              <tr key={index}>
                <td>{itemNumber}</td>
                <td>{moment(i.created_at).format('DD-MM-YYYY HH:mm')}</td>
                <td>{i.user?.full_name || i.user?.name}</td>
                <td>{parseFloat(i.amount).toFixed(2)}</td>
                <td>{STATUS_LABELS[i.status] || '-'}</td>
                <td>{i.processed_at ? moment(i.processed_at).format('DD-MM-YYYY HH:mm') : '-'}</td>
                <td className='text-right'>
                  {isPending ? (
                    <Tooltip title='Procesar solicitud'>
                      <a className='link-icon' href='#' onClick={(e: any) => this.view(e, i)}>
                        <img src={EditIcon} />
                      </a>
                    </Tooltip>
                  ) : (
                    <Tooltip title='Ver'>
                      <a className='link-icon' href='#' onClick={(e: any) => this.view(e, i)}>
                        <img src={ViewIcon} />
                      </a>
                    </Tooltip>
                  )}
                </td>
              </tr>
            );
          })}
        </Table>

        <Pagination
          pages={this.state.last_page}
          active={this.state.page}
          onChange={async (page: number) => {
            await this.setState({
              page: page,
            });
            this.load();
          }}
        />
      </div>
    );
  }
}

export default connect((state: RootState) => {
  return {
    user: state.user,
  };
})(AdminReferrals);
